{
	"es": {
		"food": "Alimento",
		"special": "Especial",
		"grains": "Granos",
		"nuts": "Nueces de árbol",
		"dietary": "Dietético",
		"description": "Descripción",
		"long_description": "descripción larga",
		"materials": "Materiales",
		"ingredients": "Ingredientes",
		"reviews": "Reseñas",
		"reviews_x": "[0] opiniones",
		"quality": "Calidad",
		"service": "Servicio",
		"price": "Precio",
		"location": "Ubicación",
		"add": "Añadir",
		"add_x": "Agregar x[0]",
		"no_choice_available": "No hay opción disponible",
		"mandatory": "Obligatorio",
		"min_x": "Mín. [0]",
		"max_x": "Máx. [0]",
		"data_processing": "Procesamiento de datos",
		"privacy_read_link": "He leído la [0]",
		"privacy_policy_link": "política de privacidad",
		"allow_marketing": "y doy mi consentimiento para el análisis de mis opciones de compra y para comunicaciones promocionales por correo electrónico",
		"change_language": "Cambiar idioma",
		"allergens_filter_line_1": "Elimine los alérgenos para ver solo los productos adecuados para usted.",
		"allergens_filter_line_2": "Todos los productos pueden contener trazas de los siguientes alérgenos.",
		"allergens_in_cart": "Productos con alérgenos en el carrito",
		"allergens_in_cart_confirm": "Hay productos en el carrito que contienen alérgenos que has elegido no mostrar. ¿Quieres conservarlos en el carrito?",
		"product_filtered": "Producto filtrado",
		"product_filtered_confirm": "Este producto contiene alérgenos que usted ha filtrado. ¿Quieres agregarlo al carrito de todos modos?",
		"category_filtered": "Categoría filtrada",
		"category_filtered_confirm": "Todos los productos de esta categoría tienen alérgenos que has filtrado. ¿Quieres eliminar estos filtros?",
		"category_filtered_search_confirm": "Todos los productos de esta categoría no coinciden con la búsqueda, ¿quieres eliminar la búsqueda?",
		"max_choice_list": "No puedes agregar más de [0] productos a la lista [1]",
		"max_choice_list_single": "No puedes agregar más de un producto a la lista [0]",
		"too_big_to_translate": "El menú es demasiado grande para traducirlo.",
		"too_big_to_translate_catalog": "El catálogo es demasiado grande para traducirlo.",
		"conditions_not_matched_list": "Condiciones no coincidentes para la lista [0]",
		"conditions_not_matched_multiple_lists": "Condiciones no coincidentes para las listas [0]",
		"not_available": "No disponible",
		"item_not_available_quantity": "En este momento no puedes pedir más de [0] [1]",
		"category_not_available_quantity": "En este momento no puedes pedir más de [0] en la categoría [1]",
		"item_not_available": "No puedes pedir el producto [0]",
		"more_info_allergens_link": "Para más información sobre alérgenos",
		"table_number": "Número de mesa",
		"phone_number": "Número de teléfono",
		"phone_number_explain": "Recibirás un mensaje cuando tu pedido esté listo.",
		"phone_country_code": "prefijo internacional",
		"missing_phone_number": "Ingrese el número de teléfono para recibir una notificación cuando el pedido esté listo",
		"missing_table_number": "Ingrese el número de la mesa",
		"missing_customer_name": "Introduzca su nombre",
		"missing_customer_email": "Introduce tu correo electrónico",
		"invalid_phone": "Numero de telefono invalido",
		"invalid_email": "Email inválido",
		"send_to_terminal": "Enviar al quiosco",
		"or_pay_online": "O pagar en línea",
		"pay_in_3_installments": "Paga en 3",
		"generic_page_description": "Descubre el [0] de [1] y todos sus productos.",
		"pay_with": "Pagar con",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"expires": "Vence [0]/[1]",
		"order_time": "Tiempo de la orden",
		"ASAP": "lo antes posible",
		"no_date": "Sin cita",
		"schedule": "Cronograma",
		"missing_address": "Introduce la dirección de entrega seleccionándola entre las sugeridas",
		"pay_now": "Pagar ahora",
		"pay_later": "Paga después",
		"cash": "Dinero",
		"other_methods": "Otro",
		"your_name": "Su nombre",
		"write_your_name": "Escribe tu nombre",
		"delivery": "Entrega",
		"takeaway": "Para llevar",
		"click_here": "haga click aquí",
		"allergens_info": "Información sobre alérgenos",
		"order_here": "Ordene aqui",
		"order_here_now": "Ordene aquí",
		"notes": "Notas",
		"order_failed": "Había un problema. Vuelva a cargar esta página e inténtelo de nuevo.",
		"order_failed_later": "Había un problema. Por favor, inténtelo de nuevo más tarde.",
		"choose_time": "Elige tiempo",
		"no_slots": "No hay cupos disponibles para esta fecha",
		"couriers": "Mensajeros",
		"no_couriers": "No hay mensajeros disponibles",
		"couriers_not_loaded": "Elija una dirección de entrega para ver los mensajeros disponibles",
		"couriers_no_cart": "Elija los productos a ordenar para ver los mensajeros disponibles",
		"missing_order_data": "Introduce nombre y teléfono para ver los mensajeros disponibles",
		"missing_sender_data": "Falta [0] dirección completa o algún dato, no es posible continuar con el pedido",
		"customer_address_incomplete": "En la dirección proporcionada falta el número de calle o el código postal, corríjalo para ver los mensajeros disponibles",
		"missing_courier": "Elige un mensajero para proceder con el pedido",
		"free_shipping_above": "Envío gratis arriba de [0]",
		"delivery_costs": "Gastos de envío",
		"takeaway_costs": "Costos para llevar",
		"courier_costs": "Costos de mensajería",
		"payment_failed": "Pago fallido",
		"pay_x": "Pagar [0]",
		"free": "Gratis",
		"days": "[0] días",
		"day": "Un día",
		"same_day": "Hoy",
		"time_x": "Hora [0]",
		"order_data": "Datos de los pedidos",
		"name": "Nombre",
		"email": "Correo electrónico",
		"phone": "Teléfono",
		"no_menus_available": "No hay productos disponibles",
		"order_now": "Ordenar ahora",
		"empty_cart": "el carrito esta vacio",
		"bollo_tax": "impuesto bollo",
		"do_you_have_coupon_code": "¿Tiene un código de cupón?",
		"discount": "Descuento",
		"coupon_code": "Código promocional",
		"coupon_invalid": "Código de cupón inválido",
		"coupon_duplicate": "Código de cupón ya utilizado",
		"coupon_min_order_value": "El código de cupón no es válido para pedidos inferiores a [0]",
		"coupon_cant_stack": "No puedes usar estos códigos de cupón juntos",
		"coupon_already_used": "Código de cupón ya utilizado",
		"coupon_mode": "Código de cupón no válido para este tipo de pedido",
		"no_linked_products": "El código de cupón no se aplica a ningún producto del carrito.",
		"use_cookies_title": "Utilizamos las cookies necesarias para el funcionamiento del sitio web.",
		"click_here_to_view": "Haga click aquí para ver",
		"the_cookie_policy": "la política de cookies",
		"cookie_info": "Para negar el consentimiento, haga click en No. Para permitir nuestras cookies, haga click en Aceptar.",
		"email_required": "Correo electronico (requerido",
		"email_required_explain": "Introduce tu email para recibir la confirmación del pedido",
		"how_many_people": "¿Cuanta gente?",
		"number_of_people": "Número de personas",
		"max_items": "No puedes pedir más de [0] productos a la vez. Si desea pedir otros productos, primero complete el pedido actual.",
		"captcha_failed": "No podemos verificar la confiabilidad de este dispositivo. Pruebe desde otro navegador o dispositivo.",
		"payment_method_unaccepted": "[0] ya no acepta este método de pago.",
		"far_away_explain": "No estás cerca de [0]. Si está utilizando una VPN, desactívela.",
		"courier_no_rate": "Seleccione un mensajero para continuar con el pedido.",
		"courier_payment_explain": "Para el envío con mensajería es necesario pagar con tarjeta, Apple Pay o Google Pay.",
		"payment_method_issue": "Hubo un problema, prueba con otro método de pago.",
		"delivery_not_accepted": "[0] no acepta pedidos de entrega en este momento.",
		"takeaway_not_accepted": "[0] no acepta pedidos para llevar en este momento.",
		"stock_invalid": "Uno o más productos en su carrito exceden la cantidad disponible.",
		"orders_queue_many": "pedidos por delante",
		"orders_queue_one": "Un pedido por delante",
		"orders_queue_empty": "No hay pedidos en cola",
		"cover_charge_invalid": "[0] no se calculó correctamente, inténtalo de nuevo.",
		"takeaway_time_invalid": "Elija un horario de recogida válido para llevar.",
		"missing_order_date": "Elige la fecha del pedido",
		"missing_order_time": "Elige el horario del pedido",
		"loading_stripe": "Sistema de pago no disponible, inténtalo nuevamente en unos segundos.",
		"saved_cards": "Tarjetas guardadas",
		"add_card": "Agregar tarjeta",
		"back_to_existing": "Volver a tarjetas guardadas",
		"pay_with_card": "pagar con tarjeta",
		"with_card": "Con tarjeta",
		"long_ago": "QR caducado",
		"long_ago_explain": "Escanee el CÓDIGO QR nuevamente para continuar con el pedido. Los productos que hayas elegido permanecerán seleccionados.",
		"min_order": "Pedido mínimo [0]",
		"no_orders_now": "[0] no acepta pedidos en este momento, inténtalo de nuevo más tarde.",
		"choose_products_explain": "Elige los productos haciendo click sobre ellos",
		"press_button_cart": "Pulsa el botón del carrito que aparece en la esquina inferior derecha.",
		"proceed_to_payment": "¡Procede al pago y disfruta de tu pedido!",
		"address": "DIRECCIÓN",
		"additional_notes": "Notas adicionales",
		"product_notes": "Notas del producto",
		"products_x": "[0] productos",
		"product_single": "Un producto",
		"back_to_menu": "Volver al menú",
		"back_to_catalog": "Volver al catálogo",
		"menu_banner": "Banner del menú",
		"cookie_policy": "Política de cookies",
		"back": "Atrás",
		"search": "Buscar",
		"logo": "Logo",
		"order_summary": "Resumen del pedido"
	},
	"fr": {
		"food": "Nourriture",
		"special": "Spécial",
		"grains": "Céréales",
		"nuts": "Noix",
		"dietary": "Diététique",
		"description": "Description",
		"long_description": "longue description",
		"materials": "Matériaux",
		"ingredients": "Ingrédients",
		"reviews": "Commentaires",
		"reviews_x": "[0] avis",
		"quality": "Qualité",
		"service": "Service",
		"price": "Prix",
		"location": "Emplacement",
		"add": "Aggiungi",
		"add_x": "Aggiungi x[0]",
		"no_choice_available": "Aucun choix disponible",
		"mandatory": "Obligatoire",
		"min_x": "Min. [0]",
		"max_x": "Max. [0]",
		"data_processing": "Traitement de l'information",
		"privacy_read_link": "J'ai lu la [0]",
		"privacy_policy_link": "politique de confidentialité",
		"allow_marketing": "et je donne mon consentement pour l'analyse de mes choix d'achat et pour les communications promotionnelles par email",
		"change_language": "Changer de langue",
		"allergens_filter_line_1": "Supprimez les allergènes pour afficher uniquement les produits qui vous conviennent.",
		"allergens_filter_line_2": "Tous les produits peuvent contenir des traces des allergènes suivants.",
		"allergens_in_cart": "Produits contenant des allergènes dans le panier",
		"allergens_in_cart_confirm": "Il y a des produits dans le panier qui contiennent des allergènes que vous avez choisi de ne pas afficher. Voulez-vous les garder dans le panier ?",
		"product_filtered": "Produit filtré",
		"product_filtered_confirm": "Ce produit contient des allergènes que vous avez filtrés. Voulez-vous quand même l’ajouter au panier ?",
		"category_filtered": "Catégorie filtrée",
		"category_filtered_confirm": "Tous les produits de cette catégorie contiennent des allergènes que vous avez filtrés. Voulez-vous supprimer ces filtres ?",
		"category_filtered_search_confirm": "Tous les produits de cette catégorie ne correspondent pas à la recherche, souhaitez-vous supprimer la recherche ?",
		"max_choice_list": "Vous ne pouvez pas ajouter plus de [0] produits à la liste [1]",
		"max_choice_list_single": "Vous ne pouvez pas ajouter plus d'un produit à la liste [0]",
		"too_big_to_translate": "Le menu est trop grand pour être traduit",
		"too_big_to_translate_catalog": "Le catalogue est trop gros pour être traduit",
		"conditions_not_matched_list": "Conditions ne correspondant pas à la liste [0]",
		"conditions_not_matched_multiple_lists": "Conditions ne correspondant pas aux listes [0]",
		"not_available": "Pas disponible",
		"item_not_available_quantity": "Pour le moment, vous ne pouvez pas commander plus de [0] [1]",
		"category_not_available_quantity": "Pour le moment, vous ne pouvez pas commander plus de [0] dans la catégorie [1]",
		"item_not_available": "Vous ne pouvez pas commander le produit [0]",
		"more_info_allergens_link": "Pour plus d’informations sur les allergènes",
		"table_number": "Numéro de tableau",
		"phone_number": "Numéro de téléphone",
		"phone_number_explain": "Vous recevrez un message lorsque votre commande sera prête.",
		"phone_country_code": "Préfixe international",
		"missing_phone_number": "Entrez le numéro de téléphone pour être averti lorsque la commande est prête",
		"missing_table_number": "Entrez le numéro du tableau",
		"missing_customer_name": "Entrez votre nom",
		"missing_customer_email": "Entrer votre Email",
		"invalid_phone": "Numéro de téléphone invalide",
		"invalid_email": "Email invalide",
		"send_to_terminal": "Envoyer au kiosque",
		"or_pay_online": "Ou payez en ligne",
		"pay_in_3_installments": "Payer en 3",
		"generic_page_description": "Découvrez le [0] de [1] et tous ses produits.",
		"pay_with": "Payer avec",
		"satispay": "Satisfaire",
		"klarna": "Klarna",
		"expires": "Expire [0]/[1]",
		"order_time": "Temps de commande",
		"ASAP": "dès que possible",
		"no_date": "Pas de date",
		"schedule": "Calendrier",
		"missing_address": "Saisissez l'adresse de livraison en la sélectionnant parmi celles proposées",
		"pay_now": "Payez maintenant",
		"pay_later": "Payer plus tard",
		"cash": "Espèces",
		"other_methods": "Autre",
		"your_name": "Votre nom",
		"write_your_name": "Écrivez votre nom",
		"delivery": "Livraison",
		"takeaway": "Emporter",
		"click_here": "Cliquez ici",
		"allergens_info": "Informations sur les allergènes",
		"order_here": "Commander ici",
		"order_here_now": "Commandez directement ici",
		"notes": "Remarques",
		"order_failed": "Il y avait un problème. Veuillez recharger cette page et réessayer.",
		"order_failed_later": "Il y avait un problème. Veuillez réessayer plus tard.",
		"choose_time": "Choisissez l'heure",
		"no_slots": "Aucun créneau disponible pour cette date",
		"couriers": "Coursiers",
		"no_couriers": "Aucun coursier disponible",
		"couriers_not_loaded": "Choisissez une adresse de livraison pour voir les coursiers disponibles",
		"couriers_no_cart": "Choisissez les produits à commander pour voir les coursiers disponibles",
		"missing_order_data": "Entrez votre nom et votre téléphone pour voir les coursiers disponibles",
		"missing_sender_data": "Il manque [0] adresse complète ou certaines données, il n'est pas possible de procéder à la commande",
		"customer_address_incomplete": "L'adresse fournie ne comporte pas le numéro de rue ou le code postal, corrigez-le pour voir les coursiers disponibles",
		"missing_courier": "Choisissez un transporteur pour procéder à la commande",
		"free_shipping_above": "Livraison gratuite au-dessus de [0]",
		"delivery_costs": "Coûts de livraison",
		"takeaway_costs": "Frais à emporter",
		"courier_costs": "Frais de messagerie",
		"payment_failed": "Paiement échoué",
		"pay_x": "Payer [0]",
		"free": "Gratuit",
		"days": "[0] jours",
		"day": "Un jour",
		"same_day": "Aujourd'hui",
		"time_x": "Temps [0]",
		"order_data": "Données de commande",
		"name": "Nom",
		"email": "E-mail",
		"phone": "Téléphone",
		"no_menus_available": "Aucun produit disponible",
		"order_now": "Commandez maintenant",
		"empty_cart": "Le panier est vide",
		"bollo_tax": "Taxe Bollo",
		"do_you_have_coupon_code": "Avez-vous un code promo?",
		"discount": "Rabais",
		"coupon_code": "Code promo",
		"coupon_invalid": "Code de Coupon Invalide",
		"coupon_duplicate": "Code promo déjà utilisé",
		"coupon_min_order_value": "Code promo non valable pour les commandes inférieures à [0]",
		"coupon_cant_stack": "Vous ne pouvez pas utiliser ces codes promo ensemble",
		"coupon_already_used": "Code promo déjà utilisé",
		"coupon_mode": "Code promo non valable pour ce type de commande",
		"no_linked_products": "Le code promo ne s'applique à aucun produit du panier",
		"use_cookies_title": "Nous utilisons les cookies nécessaires au fonctionnement du site Internet.",
		"click_here_to_view": "Cliquez ici pour afficher",
		"the_cookie_policy": "la politique des cookies",
		"cookie_info": "Pour refuser le consentement, cliquez sur Non. Pour autoriser nos cookies, cliquez sur OK.",
		"email_required": "Email (requis",
		"email_required_explain": "Entrez votre email pour recevoir la confirmation de commande",
		"how_many_people": "Combien de personnes?",
		"number_of_people": "Nombre de personnes",
		"max_items": "Vous ne pouvez pas commander plus de [0] produits à la fois. Si vous souhaitez commander d'autres produits, complétez d'abord la commande en cours.",
		"captcha_failed": "Nous ne pouvons pas vérifier la fiabilité de cet appareil. Essayez depuis un autre navigateur ou appareil.",
		"payment_method_unaccepted": "[0] n'accepte plus ce mode de paiement.",
		"far_away_explain": "Vous n'êtes pas près de [0]. Si vous utilisez un VPN, veuillez le désactiver.",
		"courier_no_rate": "Sélectionnez un transporteur pour procéder à la commande.",
		"courier_payment_explain": "Pour l'expédition par coursier, vous devez payer par carte, Apple Pay ou Google Pay.",
		"payment_method_issue": "Il y a eu un problème, essayez avec un autre mode de paiement.",
		"delivery_not_accepted": "[0] n'accepte pas les bons de livraison pour le moment.",
		"takeaway_not_accepted": "[0] n'accepte pas les commandes à emporter pour le moment.",
		"stock_invalid": "Un ou plusieurs produits dans votre panier dépassent la quantité disponible.",
		"orders_queue_many": "commandes devant vous",
		"orders_queue_one": "Une commande devant vous",
		"orders_queue_empty": "Aucune commande en file d'attente",
		"cover_charge_invalid": "[0] n'a pas été calculé correctement, veuillez réessayer.",
		"takeaway_time_invalid": "Choisissez une heure de prise en charge valide pour les plats à emporter.",
		"missing_order_date": "Choisissez la date de commande",
		"missing_order_time": "Choisissez l'heure de la commande",
		"loading_stripe": "Système de paiement non disponible, réessayez dans quelques secondes.",
		"saved_cards": "Cartes enregistrées",
		"add_card": "Ajouter une carte",
		"back_to_existing": "Retour aux cartes enregistrées",
		"pay_with_card": "Payer par carte",
		"with_card": "Par carte",
		"long_ago": "Code QR expiré",
		"long_ago_explain": "Scannez à nouveau le QR CODE pour procéder à la commande. Les produits que vous avez choisis resteront sélectionnés.",
		"min_order": "Commande minimale [0]",
		"no_orders_now": "[0] n'accepte pas de commandes pour le moment, veuillez réessayer plus tard.",
		"choose_products_explain": "Choisissez les produits en cliquant dessus",
		"press_button_cart": "Appuyez sur le bouton du panier qui apparaît dans le coin inférieur droit",
		"proceed_to_payment": "Procédez au paiement et profitez de votre commande !",
		"address": "Adresse",
		"additional_notes": "Notes complémentaires",
		"product_notes": "Notes sur le produit",
		"products_x": "[0] produits",
		"product_single": "Un produit",
		"back_to_menu": "Retour au menu",
		"back_to_catalog": "Retour au catalogue",
		"menu_banner": "Bannière de menu",
		"cookie_policy": "Politique de cookies",
		"back": "Dos",
		"search": "Recherche",
		"logo": "Logo",
		"order_summary": "Récapitulatif de la commande"
	},
	"de": {
		"food": "Essen",
		"special": "Besonders",
		"grains": "Körner",
		"nuts": "Nüsse",
		"dietary": "Diätetisch",
		"description": "Beschreibung",
		"long_description": "Lange Beschreibung",
		"materials": "Materialien",
		"ingredients": "Zutaten",
		"reviews": "Rezensionen",
		"reviews_x": "[0] Rezensionen",
		"quality": "Qualität",
		"service": "Service",
		"price": "Preis",
		"location": "Standort",
		"add": "Aggiungi",
		"add_x": "Aggiungi x[0]",
		"no_choice_available": "Keine Auswahl verfügbar",
		"mandatory": "Obligatorisch",
		"min_x": "Mindest. [0]",
		"max_x": "Max. [0]",
		"data_processing": "Datenverarbeitung",
		"privacy_read_link": "Ich habe die [0] gelesen",
		"privacy_policy_link": "Datenschutzerklärung",
		"allow_marketing": "und ich gebe mein Einverständnis zur Analyse meiner Kaufentscheidungen und zur Werbemitteilung per E-Mail",
		"change_language": "Sprache ändern",
		"allergens_filter_line_1": "Entfernen Sie Allergene, um nur die für Sie geeigneten Produkte anzuzeigen.",
		"allergens_filter_line_2": "Alle Produkte können Spuren der folgenden Allergene enthalten.",
		"allergens_in_cart": "Produkte mit Allergenen im Warenkorb",
		"allergens_in_cart_confirm": "Im Warenkorb befinden sich Produkte, die Allergene enthalten, die Sie nicht anzeigen möchten. Möchten Sie sie im Warenkorb behalten?",
		"product_filtered": "Produkt gefiltert",
		"product_filtered_confirm": "Dieses Produkt enthält Allergene, die Sie gefiltert haben. Möchten Sie es trotzdem in den Warenkorb legen?",
		"category_filtered": "Kategorie gefiltert",
		"category_filtered_confirm": "Alle Produkte in dieser Kategorie enthalten Allergene, die Sie gefiltert haben. Möchten Sie diese Filter entfernen?",
		"category_filtered_search_confirm": "Alle Produkte in dieser Kategorie stimmen nicht mit der Suche überein. Möchten Sie die Suche entfernen?",
		"max_choice_list": "Sie können der Liste [1] nicht mehr als [0] Produkte hinzufügen.",
		"max_choice_list_single": "Sie können der Liste nicht mehr als ein Produkt hinzufügen [0]",
		"too_big_to_translate": "Die Speisekarte ist zu umfangreich, um übersetzt zu werden",
		"too_big_to_translate_catalog": "Der Katalog ist zu umfangreich, um übersetzt zu werden",
		"conditions_not_matched_list": "Bedingungen für Liste [0] nicht erfüllt",
		"conditions_not_matched_multiple_lists": "Bedingungen für [0] Listen nicht erfüllt",
		"not_available": "Nicht verfügbar",
		"item_not_available_quantity": "Zurzeit können Sie nicht mehr als [0] [1] bestellen.",
		"category_not_available_quantity": "Derzeit können Sie nicht mehr als [0] in der Kategorie [1] bestellen.",
		"item_not_available": "Sie können das Produkt nicht bestellen [0]",
		"more_info_allergens_link": "Weitere Informationen zu Allergenen",
		"table_number": "Tisch Nummer",
		"phone_number": "Telefonnummer",
		"phone_number_explain": "Sie erhalten eine Nachricht, wenn Ihre Bestellung fertig ist.",
		"phone_country_code": "Internationales Präfix",
		"missing_phone_number": "Geben Sie die Telefonnummer ein, um benachrichtigt zu werden, wenn die Bestellung fertig ist",
		"missing_table_number": "Geben Sie die Tischnummer ein",
		"missing_customer_name": "Gib deinen Namen ein",
		"missing_customer_email": "Geben sie ihre E-Mail Adresse ein",
		"invalid_phone": "Ungültige Telefonnummer",
		"invalid_email": "Ungültige E-Mail",
		"send_to_terminal": "An Kiosk senden",
		"or_pay_online": "Oder zahlen Sie online",
		"pay_in_3_installments": "Zahlen Sie in 3",
		"generic_page_description": "Entdecken Sie [0] von [1] und alle seine Produkte.",
		"pay_with": "Bezahlen mit",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"expires": "Läuft ab [0]/[1]",
		"order_time": "Bestellzeitpunkt",
		"ASAP": "schnellstmöglich",
		"no_date": "Kein Datum",
		"schedule": "Zeitplan",
		"missing_address": "Geben Sie die Lieferadresse ein, indem Sie sie aus den Vorschlägen auswählen",
		"pay_now": "Zahlen Sie jetzt",
		"pay_later": "Später bezahlen",
		"cash": "Kasse",
		"other_methods": "Andere",
		"your_name": "Ihr Name",
		"write_your_name": "Schreib deinen Namen",
		"delivery": "Lieferung",
		"takeaway": "Wegbringen",
		"click_here": "klicken Sie hier",
		"allergens_info": "Informationen zu Allergenen",
		"order_here": "Bestell hier",
		"order_here_now": "Bestellen Sie direkt hier",
		"notes": "Anmerkungen",
		"order_failed": "Es gab ein Problem. Bitte laden Sie diese Seite neu und versuchen Sie es erneut.",
		"order_failed_later": "Es gab ein Problem. Bitte versuchen Sie es später noch einmal.",
		"choose_time": "Wählen Sie die Zeit",
		"no_slots": "Für dieses Datum sind keine Plätze verfügbar",
		"couriers": "Kuriere",
		"no_couriers": "Keine Kuriere verfügbar",
		"couriers_not_loaded": "Wählen Sie eine Lieferadresse, um die verfügbaren Kuriere anzuzeigen",
		"couriers_no_cart": "Wählen Sie die zu bestellenden Produkte aus, um die verfügbaren Kuriere anzuzeigen",
		"missing_order_data": "Geben Sie Ihren Namen und Ihre Telefonnummer ein, um die verfügbaren Kuriere anzuzeigen",
		"missing_sender_data": "Fehlt [0] die vollständige Adresse oder einige Daten, ist es nicht möglich, mit der Bestellung fortzufahren",
		"customer_address_incomplete": "Bei der angegebenen Adresse fehlt die Hausnummer oder Postleitzahl. Korrigieren Sie diese, um die verfügbaren Kuriere anzuzeigen",
		"missing_courier": "Wählen Sie einen Kurier aus, um mit der Bestellung fortzufahren",
		"free_shipping_above": "Kostenloser Versand über [0]",
		"delivery_costs": "Versandkosten",
		"takeaway_costs": "Kosten zum Mitnehmen",
		"courier_costs": "Kurierkosten",
		"payment_failed": "Bezahlung fehlgeschlagen",
		"pay_x": "Zahlen Sie [0]",
		"free": "Frei",
		"days": "[0] Tage",
		"day": "Einmal",
		"same_day": "Heute",
		"time_x": "Zeit [0]",
		"order_data": "Bestelldaten",
		"name": "Name",
		"email": "Email",
		"phone": "Telefon",
		"no_menus_available": "Keine Produkte verfügbar",
		"order_now": "Jetzt bestellen",
		"empty_cart": "Der Warenkorb ist leer",
		"bollo_tax": "Bollo-Steuer",
		"do_you_have_coupon_code": "Haben Sie einen Gutscheincode?",
		"discount": "Rabatt",
		"coupon_code": "Gutscheincode",
		"coupon_invalid": "Ungültiger Gutscheincode",
		"coupon_duplicate": "Gutscheincode bereits verwendet",
		"coupon_min_order_value": "Gutscheincode nicht gültig für Bestellungen unter [0]",
		"coupon_cant_stack": "Sie können diese Gutscheincodes nicht zusammen verwenden",
		"coupon_already_used": "Gutscheincode bereits verwendet",
		"coupon_mode": "Der Gutscheincode ist für diese Art von Bestellung nicht gültig",
		"no_linked_products": "Der Gutscheincode gilt nicht für die Produkte im Warenkorb",
		"use_cookies_title": "Wir verwenden die für den Betrieb der Website notwendigen Cookies.",
		"click_here_to_view": "Klicke hier, um anzusehen",
		"the_cookie_policy": "die Cookie-Richtlinie",
		"cookie_info": "Um die Einwilligung zu verweigern, klicken Sie auf Nein. Um unsere Cookies zuzulassen, klicken Sie auf OK.",
		"email_required": "Email (erforderlich",
		"email_required_explain": "Geben Sie Ihre E-Mail-Adresse ein, um die Bestellbestätigung zu erhalten",
		"how_many_people": "Wie viele Leute?",
		"number_of_people": "Anzahl der Personen",
		"max_items": "Sie können nicht mehr als [0] Produkte gleichzeitig bestellen. Wenn Sie weitere Produkte bestellen möchten, schließen Sie zunächst die aktuelle Bestellung ab.",
		"captcha_failed": "Wir können die Zuverlässigkeit dieses Geräts nicht überprüfen. Versuchen Sie es mit einem anderen Browser oder Gerät.",
		"payment_method_unaccepted": "[0] akzeptiert diese Zahlungsmethode nicht mehr.",
		"far_away_explain": "Sie sind nicht in der Nähe von [0]. Wenn Sie ein VPN verwenden, deaktivieren Sie es bitte.",
		"courier_no_rate": "Wählen Sie einen Kurier aus, um mit der Bestellung fortzufahren.",
		"courier_payment_explain": "Für den Versand per Kurier müssen Sie mit Karte, Apple Pay oder Google Pay bezahlen.",
		"payment_method_issue": "Es ist ein Problem aufgetreten. Versuchen Sie es mit einer anderen Zahlungsmethode.",
		"delivery_not_accepted": "[0] akzeptiert derzeit keine Lieferaufträge.",
		"takeaway_not_accepted": "[0] akzeptiert derzeit keine Bestellungen zum Mitnehmen.",
		"stock_invalid": "Ein oder mehrere Produkte in Ihrem Warenkorb überschreiten die verfügbare Menge.",
		"orders_queue_many": "Bestellungen vor Ihnen",
		"orders_queue_one": "Eine Bestellung vor Ihnen",
		"orders_queue_empty": "Keine Bestellungen in der Warteschlange",
		"cover_charge_invalid": "[0] wurde nicht korrekt berechnet, bitte versuchen Sie es erneut.",
		"takeaway_time_invalid": "Wählen Sie eine gültige Abholzeit zum Mitnehmen.",
		"missing_order_date": "Wählen Sie das Bestelldatum",
		"missing_order_time": "Wählen Sie die Bestellzeit",
		"loading_stripe": "Das Zahlungssystem ist nicht verfügbar. Versuchen Sie es in ein paar Sekunden erneut.",
		"saved_cards": "Gespeicherte Karten",
		"add_card": "Karte hinzufügen",
		"back_to_existing": "Zurück zu den gespeicherten Karten",
		"pay_with_card": "Bezahlen Sie mit Karte",
		"with_card": "Mit Karte",
		"long_ago": "QR abgelaufen",
		"long_ago_explain": "Scannen Sie den QR-CODE erneut, um mit der Bestellung fortzufahren. Die von Ihnen ausgewählten Produkte bleiben ausgewählt.",
		"min_order": "Mindestbestellmenge [0]",
		"no_orders_now": "[0] nimmt derzeit keine Bestellungen entgegen. Bitte versuchen Sie es später erneut.",
		"choose_products_explain": "Wählen Sie die Produkte aus, indem Sie darauf klicken",
		"press_button_cart": "Klicken Sie auf die Warenkorb-Schaltfläche, die unten rechts angezeigt wird",
		"proceed_to_payment": "Fahren Sie mit der Zahlung fort und genießen Sie Ihre Bestellung!",
		"address": "Adresse",
		"additional_notes": "Zusätzliche Bemerkungen",
		"product_notes": "Produkthinweise",
		"products_x": "[0] Produkte",
		"product_single": "Ein Produkt",
		"back_to_menu": "Zurück zum Menü",
		"back_to_catalog": "Zurück zum Katalog",
		"menu_banner": "Menübanner",
		"cookie_policy": "Cookie-Richtlinie",
		"back": "Zurück",
		"search": "Suchen",
		"logo": "Logo",
		"order_summary": "Bestellübersicht"
	}
}